import { BasketState } from '@front/common/src/ducks/customer/types';
import { MODIFICATION_MODES } from '@front/common/src/constants/basket';
import { UniverseReference, User } from '@front/common/src/types/commons';
import { isCleaningReference } from '@front/common/src/utils/universes';
import { getCurrentCountry } from '@front/common/src/utils/country';

import { hasMembership, hasRecurrentMembership } from '../../utils/membership';
import { MEMBERSHIP_CONFIG_BY_COUNTRY } from '../../constants/country-config';

export type UseShouldShowMembershipCardForModeParams = {
  mode?: BasketState['mode'];
  user?: User;
  isCleaningSpot: boolean;
  hasOrWantsMembership?: boolean;
  universeReference: UniverseReference;
  isDisplayedAsPreview?: boolean;
};

const useShouldShowMembershipCard = ({
  mode = 'creation',
  user,
  isCleaningSpot,
  hasOrWantsMembership,
  universeReference,
  isDisplayedAsPreview = false,
}: UseShouldShowMembershipCardForModeParams) => {
  const isMembershipAvailable = MEMBERSHIP_CONFIG_BY_COUNTRY[getCurrentCountry()].isAvailable;
  const isCleaning = isCleaningReference(universeReference);

  if (!isMembershipAvailable) return false;

  // For cleaning, if a customer does not have any membership or is not signed in,
  // we don't show the MembershipCard preview above the basket
  if (isCleaning && isDisplayedAsPreview && !hasMembership(user)) {
    return false;
  }

  // For a customer who is already a recurrent member, do not show the MembershipCard preview
  // above the basket if recurring cleaning is selected
  if (isCleaning && isDisplayedAsPreview && hasRecurrentMembership(user) && !isCleaningSpot) {
    return false;
  }

  if (mode === 'creation') return true;

  // Never show the card when modifying cleaning recurring
  if (mode && MODIFICATION_MODES.includes(mode) && (isCleaningSpot || !isCleaning)) {
    return !!hasOrWantsMembership;
  }

  return false;
};

export default useShouldShowMembershipCard;
